import React from 'react';
import { useBrowserSupport } from 'src/lib/hooks/useBrowserSupport';
import BrowserWarning from 'src/components/page/BrowserWarning/BrowserWarning';

const BrowserCheck: React.FC<WithChildren> = ({ children }) => {
  const { supportedBrowser, scenario } = useBrowserSupport();
  // determines if this is a device-check or appointment workflow based on url path
  const workflow = window.location.pathname.match(/^\/device-check/) ? 'DEVICECHECK' : 'APPOINTMENT';
  return (
    <>
      {(!supportedBrowser && scenario && <BrowserWarning workflow={workflow} unsupportedBrowserKey={scenario} />) ||
        children}
    </>
  );
};

export default BrowserCheck;
